module.exports = __webpack_public_path__ + "img/taxis.c2a1b62e.jpeg";